module.exports = __webpack_public_path__ + "media/images/button_arrow_blue-54933f981018bc4dd19466d9c0e4ac03.png";